import React from 'react'
import {StockData} from '../../Route/SubLinkJSON';
import SubLink from '../../Route/SubLink';
function StockManager() {
    
  return (
    <div>
    <SubLink sublinks={StockData}/>
    </div>
  )
}

export default StockManager
